import { render, staticRenderFns } from "./ProcedureCheck.vue?vue&type=template&id=c0e10e68&"
import script from "./ProcedureCheck.vue?vue&type=script&lang=js&"
export * from "./ProcedureCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports